import { getGlobalSettings } from "../api/globalSettings/requests";
import { useQuery } from "@tanstack/react-query";

function useStoryblokGlobalSettings() {
  const {data} = useQuery({
    queryKey: ["globalSettings"],
    queryFn: getGlobalSettings,
    staleTime: Infinity,
    placeholderData: {},
  });

  return data;
}

export { useStoryblokGlobalSettings };
